import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Select,
  Table,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Skeleton,
} from "antd";
import IconButtonWithTooltip from "../../../../components/AddCompany/IconButtonWithTooltip";

import { isEmpty } from "lodash";
import {
  EditOutlined,
  DeleteOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

import DynamicCircularAddTemplete from "./addTemplate";
import {
  actionForGetAllCircularPlanningTemplate,
  actionForGetCircularPlanningCompanyDtos,
  actionForUpdateCircularPlanningCompany,
  actionForAddCircularPlanningCompanyFromList,
} from "services/redux/Reference/DynamicCircularTemplate/action";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { getCompanyorPersonEmailAddess } from "services/redux/contact/contact.action";
import { actionForAddCompanyOrContactPersonEmailAddById } from "services/redux/Reference/action";
import EditCompanyModel from "components/AddCompany/EditCompanyModal";
import { getContactPersonPagination } from "services/redux/contact/companypeople/action";
import { a } from "react-spring";

const { Option } = Select;

const DynamicCircularTemplate = ({ selectedTemplate, setSelectedTemplate }) => {
  const dispatch = useDispatch();

  const [companyDtosData, setCompanyDtosData] = useState([]);

  const {
    allCircularPlanningTemplateResp,
    getDynamicCircularPlanningCompanyDtosResp,
    getDynamicCircularPlanningCompanyDtosLoading,
  } = useSelector((state) => state.dynamicCircular);

  //const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [dynamicCirListing, setDynamicCirListing] = useState([]);

  useEffect(() => {
    if (!isEmpty(allCircularPlanningTemplateResp)) {
      setDynamicCirListing(allCircularPlanningTemplateResp);
    }
  }, [allCircularPlanningTemplateResp]);

  useEffect(() => {
    if (getDynamicCircularPlanningCompanyDtosResp) {
      console.log(
        "getDynamicCircularPlanningCompanyDtosResp: ",
        getDynamicCircularPlanningCompanyDtosResp
      );
      setCompanyDtosData(getDynamicCircularPlanningCompanyDtosResp);
    }
  }, [getDynamicCircularPlanningCompanyDtosResp]);

  useEffect(() => {
    dispatch(actionForGetAllCircularPlanningTemplate());
  }, []);

  const [isCircularAddEditModalOpen, setIsCircularAddEditModalOpen] =
    useState(false);
  const [circularAddEdit, setCircularAddEdit] = useState({
    add: false,
    edit: false,
    data: {},
  });

  const [addModalVisible, setAddModalVisible] = useState(false);
  const [addForm] = Form.useForm();
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Remove duplicate isCircularEditVisible state and use only one
  // Replace all usage of setEditModalVisible and editModalVisible with setIsCircularEditVisible and isCircularEditVisible
  // Remove editModalVisible and setEditModalVisible

  const [isCircularEditVisible, setIsCircularEditVisible] = useState(false);
  const [editingCompany, setEditingCompany] = useState(null);
  const [form] = Form.useForm();

  const [circularCompanyEdit, setCircularCompanyEdit] = useState([]);

  const [selectedId, setSelectedId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [valueRadioAddCompany, setValueRadioAddCompany] = useState("");
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [selectedAttendees, setSelectedAttendees] = useState([]); // <-- add this
  const [emailReferenceId, setEmailReferenceId] = useState(null); // <-- add this
  const [isPersonModalVisible, setIsPersonModalVisible] = useState(false); // <-- add this
  const [data, setData] = useState([]); // for options in 'Attention to'
  const [formQuickAddPerson] = Form.useForm(); // <-- add this
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  // const [form] = Form.useForm();
  const [formCircularEdit] = Form.useForm();
  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  const onFinishCircularEdit = async (values) => {
    try {
      const updatedCompany = {
        ...editingCompany,
        id: editingCompany.id,
        companyId: editingCompany.companyId,
        circularPlanningTemplateId: selectedTemplate?.id,
        companyName: editingCompany.companyName,
        priority: parseInt(values.priority),
        modeofCommunication: values.modeofCommunication,
        remarks: values.remarks || "",
        isActive: true,
        attentionTo: editingCompany.attentionTo || "[]",
      };
      await dispatch(actionForUpdateCircularPlanningCompany(updatedCompany));
      if (!isMounted.current) return;
      message.success("Company updated successfully");
      await dispatch(
        actionForGetCircularPlanningCompanyDtos(selectedTemplate.id)
      );
      if (!isMounted.current) return;
      handleEditCancel();
    } catch (error) {
      if (!isMounted.current) return;
      message.error(error.message || "Failed to update company");
    }
  };

  const handleDeleteCompany = (record) => {
    let deletePayload = {
      ...record,
      isActive: false,
    };

    dispatch(actionForUpdateCircularPlanningCompany(deletePayload));
  };

  const mapNumberToModeOfCommunication = (number) => {
    switch (number) {
      case 1:
        return "Email";
      case 2:
        return "Facebook";
      case 3:
        return "Whatsapp";
      case 4:
        return "Twitter";
      case 5:
        return "Other";
      default:
        return "Other";
    }
  };

  const handleCircularCompanyEdit = (record) => {
    if (!record) return;

    // const {
    //   attentionTo = "[]",
    //   companyId,
    //   companyName = "",
    //   remarks = "",
    //   modeofCommunication = "",
    // } = record;
    const attentionToArray = JSON.parse(record?.attentionTo || "[]");
    let mailAddressss = JSON.parse(record?.emailTo || "[]");

    let selectedPersonIds =
      attentionToArray &&
      attentionToArray?.map((item) => ({
        contactPersonIds: item?.AttentionId,
      }));

    if (record.companyId) {
      dispatch(getContactPersonPagination({ CompanyId: record.companyId }));
      dispatch(
        getCompanyorPersonEmailAddess(selectedPersonIds, record.companyId)
      );
    }

    const modeOfCommunicationString = mapNumberToModeOfCommunication(
      record?.modeofCommunication
    );

    formCircularEdit.setFieldsValue({
      // CompanyName: companyName,
      // contactCompanyId: companyId || "",
      // attendees: attentionToArray.map((item) => item.AttentionTo) || [],
      // remarks: remarks ?? "",
      // ModeofCommunication: record?.modeofCommunication ?? "",
      // mailTo: mailAddressss || [],
      CompanyName: record?.partyName || "",
      contactCompanyId: record?.contactCompanyId || "",
      attendees:
        (attentionToArray &&
          attentionToArray.map((item) => item.AttentionTo)) ||
        [],
      mailTo: mailAddressss || [],
      remarks: record?.remarks ?? "",
      priority: record?.priority ?? "",
    });

    // const communicationMap = {
    //   Email: "1",
    //   Facebook: "2",
    //   Whatsapp: "3",
    //   Twitter: "4",
    //   Other: "5",
    // };

    // setValueRadioAddCompany(communicationMap[modeofCommunication] || "1");
    switch (record?.modeofCommunication) {
      case "Email":
        setValueRadioAddCompany("1");
        break;
      case "Facebook":
        setValueRadioAddCompany("2");
        break;
      case "Whatsapp":
        setValueRadioAddCompany("3");
        break;
      case "Twitter":
        setValueRadioAddCompany("4");
        break;
      case "Other":
        setValueRadioAddCompany("5");
        break;
      default:
        setValueRadioAddCompany("1");
    }
  };

  const handleEditSubmit = async () => {
    try {
      const values = await form.validateFields();
      const updatedCompany = {
        ...editingCompany,
        id: editingCompany.id,
        companyId: editingCompany.companyId,
        circularPlanningTemplateId: selectedTemplate?.id,
        companyName: editingCompany.companyName,
        priority: parseInt(values.priority),
        modeofCommunication: values.modeofCommunication,
        remarks: values.remarks || "",
        isActive: true,
        attentionTo:
          Array.isArray(values.attendees) && values.attendees.length > 0
            ? values.attendees.join(",")
            : "",
        emailTo:
          Array.isArray(values.mailTo) && values.mailTo.length > 0
            ? values.mailTo.join(",")
            : "",
      };
      await dispatch(actionForUpdateCircularPlanningCompany(updatedCompany));
      if (!isMounted.current) return;
      message.success("Company updated successfully");
      await dispatch(
        actionForGetCircularPlanningCompanyDtos(selectedTemplate?.id)
      );
      if (!isMounted.current) return;
      handleEditCancel();
    } catch (error) {
      if (!isMounted.current) return;
      console.error("Form validation error:", error);
      message.error("Please fill in all required fields");
    }
  };
  // Removed obsolete formCircularEdit.setFieldsValue and switch(record?.modeofCommunication) block that referenced undefined variables

  // const communicationMap = {
  //   Email: "1",
  //   Facebook: "2",
  //   Whatsapp: "3",
  //   Twitter: "4",
  //   Other: "5",
  // };

  // setValueRadioAddCompany(communicationMap[modeofCommunication] || "1");

  const handleEditCancel = () => {
    setIsCircularEditVisible(false);
    setEditingCompany(null);
    form.resetFields();
  };
  const handleAddCompanyEmail = () => {
    if (!editingCompany) {
      message.error("Please select a company first");
      return;
    }
    setIsAddCompanyEmailModalOpen(true);
  };
  const handleAddCompanyPerson = () => {
    if (!editingCompany) {
      message.error("Please select a company first");
      return;
    }
    setIsPersonModalVisible(true);
  };
  const handleAddCompany = () => {
    if (!selectedTemplate) {
      message.error("Please select a template first");
      return;
    }

    try {
      setSelectedCompany(null);
      addForm.setFieldsValue({
        companyName: "",
        priority: "1",
        modeofCommunication: "Email",
        remarks: "",
      });
      setAddModalVisible(true);
    } catch (error) {
      console.error("Error in handleAddCompany:", error);
      message.error("Failed to open add modal");
    }
  };

  const handleAddSubmit = async () => {
    try {
      const values = await addForm.validateFields();
      const newCompany = {
        circularPlanningTemplateId: selectedTemplate?.id,
        companyName: values.companyName,
        priority: parseInt(values.priority),
        modeofCommunication: values.modeofCommunication,
        attentionToArray: selectedAttendees,
        emailTo: values.mailTo || [],
        remarks: values.remarks || "",
        isActive: true,
        attentionTo: "[]",
      };
      dispatch(actionForAddCircularPlanningCompanyFromList(newCompany))
        .then(async () => {
          if (!isMounted.current) return;
          message.success("Company added successfully");
          await dispatch(
            actionForGetCircularPlanningCompanyDtos(selectedTemplate.id)
          );
          if (!isMounted.current) return;
          handleEditCancel();
        })
        .catch((error) => {
          if (!isMounted.current) return;
          console.error("Add error:", error);
          message.error(error.message || "Failed to add company");
        });
    } catch (error) {
      if (!isMounted.current) return;
      console.error("Form validation error:", error);
      message.error("Please fill in all required fields");
    }
  };

  const columns = [
    {
      title: "S.N",
      key: "sno",
      render: (text, object, index) => index + 1,
      width: "5%",
    },
    {
      title: "Company",
      dataIndex: "companyName",
      key: "companyName",
      width: "40%",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: "15%",
    },
    {
      title: "Modee",
      dataIndex: "modeofCommunication",
      key: "modeofCommunication",
      width: "20%",
    },
    {
      title: "Action",
      width: "20%",
      render: (record) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <EditOutlined
            onClick={() => {
              console.log("record", record);
              handleCircularCompanyEdit(record);
              setSelectedCompanyId(record?.companyId);
              setSelectedId(record?.id);
              setSelectedCompanyName(record?.companyName);
              setSelectedAttendees(JSON.parse(record?.emailTo || "[]"));
              setIsCircularEditVisible(true);
            }}
            style={{
              cursor: "pointer",
              color: "#1890ff",
              fontSize: "16px",
            }}
          />
          <DeleteOutlined
            onClick={() => handleDeleteCompany(record)}
            style={{
              cursor: "pointer",
              color: "#ff4d4f",
              fontSize: "16px",
            }}
          />
        </div>
      ),
    },
  ];

  // Add missing state and handlers for edit modal
  const [isAddCompanyEmailModalOpen, setIsAddCompanyEmailModalOpen] =
    useState(false);
  const [searchKeywordContactPerson, setSearchKeywordContactPerson] =
    useState("");
  const [contactPersonPaginationLoading, setContactPersonPaginationLoading] =
    useState(false);

  const onChangeAddCompany = (value) => {
    setValueRadioAddCompany(value);
  };

  // Handler for 'Attention to' select change
  const handleSelectChange = (values, options) => {
    // Map selected options to attendee objects
    const selectedData = options.map((option) => ({
      AttentionTo: option.props.children,
      AttentionId: option.key,
    }));
    setSelectedAttendees(selectedData);

    // Prepare payload for fetching emails
    const selectedPersonIds = selectedData.map((item) => ({
      contactPersonIds: item.AttentionId,
    }));
    if (selectedPersonIds.length > 0 && editingCompany?.companyId) {
      // Fetch emails for selected persons and company
      dispatch(
        getCompanyorPersonEmailAddess(
          selectedPersonIds,
          editingCompany.companyId
        )
      );
    }
  };

  // Handler for Add Company Email modal close
  const handleAddCompanyEmailModalClose = () => {
    form.resetFields();
    setIsAddCompanyEmailModalOpen(false);
  };

  // Handler for Add Company Email form submit
  const onFinishAddCompanyEmail = async (values) => {
    const body = {
      companyId: editingCompany?.companyId,
      email: values?.newEmail ?? "",
    };
    setIsAddCompanyEmailModalOpen(true);
    try {
      if (body.companyId) {
        await dispatch(actionForAddCompanyOrContactPersonEmailAddById(body));
        handleAddCompanyEmailModalClose();
        if (editingCompany?.companyId) {
          dispatch(
            getCompanyorPersonEmailAddess(null, editingCompany.companyId)
          );
        }
      }
    } catch (err) {
      message.error("Failed to add company email");
    } finally {
      setIsAddCompanyEmailModalOpen(false);
    }
  };

  const { contactCompanyPersonMailResponse } = useSelector(
    (state) => state.contact
  );

  const handleAddCancel = () => {
    setAddModalVisible(false);
    addForm.resetFields();
  };

  return (
    <>
      <div>
        <h3>Dynamic Circular Template</h3>
      </div>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <Select
          style={{ width: "100%", marginBottom: "10px" }}
          placeholder="Select a template"
          allowClear
          size="small"
          showSearch={true}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(value) => {
            const selectedObj = dynamicCirListing.find(
              (item) => item.id === value
            );
            console.log("selectedTemplate", selectedTemplate);
            setSelectedTemplate(selectedObj);
            //Get All the Company List
            dispatch(actionForGetCircularPlanningCompanyDtos(selectedObj?.id));
          }}
        >
          {dynamicCirListing?.map((type) => {
            return (
              <Option key={type.id} value={type.id}>
                {type.title}
              </Option>
            );
          })}
        </Select>
        <Button
          type="primary"
          onClick={() => {
            setIsCircularAddEditModalOpen(true);
            setCircularAddEdit({ add: true, edit: false, data: {} });
          }}
          style={{ marginBottom: "10px" }}
        >
          Add
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setCircularAddEdit({
              add: false,
              edit: true,
              data: {
                ...selectedTemplate,
              },
            });
            setIsCircularAddEditModalOpen(true);
          }}
          style={{ marginBottom: "10px" }}
        >
          Edit
        </Button>

        {/* Add your modal component here */}
        <DynamicCircularAddTemplete
          isOpen={isCircularAddEditModalOpen}
          onCancel={() => setIsCircularAddEditModalOpen(false)}
          modalData={circularAddEdit}
          setIsCircularAddEditModalOpen={setIsCircularAddEditModalOpen}
          circularTemplateTitle="Add Dynamic Template"
          isCircularAddEditModalOpen={isCircularAddEditModalOpen}
          circularAddEdit={circularAddEdit}
          onSave={(savedData) => {
            // Handle save action
            console.log("Saved data:", savedData);
            setIsCircularAddEditModalOpen(false);
          }}
        />
      </div>
      <Table
        dataSource={companyDtosData}
        columns={columns}
        loading={getDynamicCircularPlanningCompanyDtosLoading}
      />
      <Modal
        title="Add Company Template"
        visible={addModalVisible}
        open={addModalVisible}
        onCancel={handleAddCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={500}
        centered
        footer={[
          <Button key="close" onClick={handleAddCancel}>
            Close
          </Button>,
          <Button key="submit" type="primary" onClick={handleAddSubmit}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          layout="vertical"
          initialValues={{
            modeofCommunication: "Email",
            priority: "1",
          }}
        >
          <Form.Item
            name="companyName"
            label="Company Name"
            rules={[{ required: true, message: "Please enter company name" }]}
            style={{ marginBottom: "15px" }}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="priority"
            label="Priority"
            rules={[{ required: true, message: "Please select priority" }]}
            style={{ marginBottom: "15px" }}
          >
            <Select>
              <Option value="1">1</Option>
              <Option value="2">2</Option>
              <Option value="3">3</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="modeofCommunication"
            label="Mode of Communication"
            rules={[
              {
                required: true,
                message: "Please select mode of communication",
              },
            ]}
            style={{ marginBottom: "15px" }}
          >
            <Select>
              <Option value="1">Email</Option>
              <Option value="2">Facebook</Option>
              <Option value="3">Whatsapp</Option>
              <Option value="4">Twitter</Option>
              <Option value="5">Other</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="remarks"
            label="Remarks"
            style={{ marginBottom: "15px" }}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </Form>
      </Modal>
      <EditCompanyModel
        emailReferenceId={emailReferenceId}
        isCircularEditVisible={isCircularEditVisible}
        setIsCircularEditVisible={setIsCircularEditVisible}
        record={circularCompanyEdit}
        form={formCircularEdit}
        selectedId={selectedId}
        selectedCompanyId={selectedCompanyId}
        setSelectedCompanyId={setSelectedCompanyId}
        valueRadioAddCompany={valueRadioAddCompany}
        setValueRadioAddCompany={setValueRadioAddCompany}
        selectedAttendees={selectedAttendees}
        setSelectedAttendees={setSelectedAttendees}
        selectedMenuItem={selectedTemplate?.id}
        selectedCompanyName={selectedCompanyName}
      />
    </>
  );
};

export default DynamicCircularTemplate;
